// extracted by mini-css-extract-plugin
export default {"topBlock":"zWE2nZMfmfW3kBuAU7GC","leftItems":"wL7jlh2NNsILfowNMGJ1","rightItems":"lmGbQpXgZ4yNtOZaa4JH","tabsList":"I_Fc0anibquhs9Noxpbn"};